import { HelpersService } from 'src/app/services';
import { Subscription } from 'rxjs';
import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from '@angular/forms';
import { AppConfig } from 'src/app/app.config';
import { PartnerService } from 'src/app/services/partner.service';
import moment from 'moment';
import { UserService } from '../../../services/user.service';
import { CyclistService } from '../../../services/cyclist.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { TechnicianService } from '../../../services/technician.service';

@Component({
  selector: 'app-add-edit-user-v2',
  templateUrl: './add-edit-user-v2.component.html',
  styleUrls: ['./add-edit-user-v2.component.scss'],
})
export class AddEditUserV2Component implements OnInit {
  @Input() messageService: MessageService;
  @Input() allocatedTechnicians;
  @Input() techniciansAllowed;
  @Input() isWorkshop = true;
  @Input() isRentals = false;

  public step = 1;
  public UserForm: FormGroup;
  public user: any = {};
  public busy = false;
  public partner: any = {};
  public error = false;
  public DefaultUnitOfMeasure = 1;
  public errorMessage = '';
  public message = '';
  public userExists: boolean = false;
  public userLinkedToPartner: boolean = false;
  public userToLink: any;
  public userView: string = null;
  public partnerID: number = 0;

  public isCurrentUserAdmin = false;
  public isCurrentUserWorkshopManager = false;
  public isSuperUser: boolean = false;

  public isTechnician = false;
  public isFitter = false;
  public isAdmin = false;
  public isWorkshopManager = false;
  public isServiceLead = false;
  public isShopRideAdmin = false;

  constructor(
    public cyclistService: CyclistService,
    private fb: FormBuilder,
    public modal: NgbActiveModal,
    private appConfig: AppConfig,
    private partnerService: PartnerService,
    private helpersService: HelpersService,
    public userService: UserService,
    private translate: TranslateService,
    public technicianService: TechnicianService,
    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    this.partnerID = this.helpersService.getPartnerId();

    if (!this.isWorkshop) {
      this.isAdmin = true;
    }

    this.setupValidation();
    this.isCurrentUserAdmin =
      this.helpersService
        .getProfileData()
        .UserRoles.filter((x) => {
          return x.PartnerID === this.partnerID;
        })
        .map((x) => {
          return x.RoleID;
        })
        .indexOf(2) > -1 || this.helpersService.getProfileData().IsSuperUser;

    this.isCurrentUserWorkshopManager = this.helpersService
      .getProfileData()
      .UserRoles.filter((x) => {
        return x.PartnerID === this.partnerID;
      })
      .map((x) => {
        return x.RoleID;
      })
      .indexOf(3) > -1;
  }

  setupValidation() {
    this.UserForm = this.fb.group({
      Name: new FormControl(this.user.Name, Validators.required),
      Surname: new FormControl(this.user.Surname, Validators.nullValidator),
      Email: new FormControl(this.user.Email, [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
      ]),
      PhoneNumber: new FormControl(
        this.user.PhoneNumber,
        Validators.nullValidator,
      ),
      Password: new FormControl('', Validators.required),
      ConfirmPassword: new FormControl('', Validators.required),
    });
  }

  modelChanged(e, type) {
    if (type === 'Admin') { this.isWorkshopManager = false; this.isServiceLead = false; this.isShopRideAdmin = false; }
    if (type === 'WorkshopManager') { this.isAdmin = false; this.isServiceLead = false; this.isShopRideAdmin = false; }
    if (type === 'ServiceLead') { this.isAdmin = false; this.isWorkshopManager = false; this.isShopRideAdmin = false; }
    if (type === 'Technician') { this.isShopRideAdmin = false; }
    if (type === 'Fitter') { this.isShopRideAdmin = false; }
    if (type === 'ShopRideAdmin') { this.isAdmin = false; this.isWorkshopManager = false; this.isServiceLead = false; this.isTechnician = false; this.isFitter = false; }
  }

  searchUser(event) {
    this.user.PartnerID = this.partnerID;

    //Only want to do the search on new users (Who won't have a user ID yet)
    if (!this.user.ID) {
      this.cyclistService
        .searchUser(this.UserForm.controls['Email'].value)
        .subscribe((searchResults) => {
          //User exists, disable and show relavant action
          if (searchResults && searchResults.length > 0) {
            this.userExists = true;
            this.userToLink = {};
            searchResults[0].UserRoles.filter((x) => {
              return x.PartnerID === this.partner.ID;
            });
            if (
              searchResults[0].UserRoles.filter((x) => {
                return x.PartnerID === this.partner.ID;
              }).length > 0
            ) {
              //User exists and is linked to a partner
              this.userLinkedToPartner = true;
              this.error = true;
              this.errorMessage = this.translate.instant(
                'messages.user_exists_linked_to_bikeshop',
              );
            } else {
              //User exists but is not linked to a partner
              this.userLinkedToPartner = false;
              this.errorMessage = this.translate.instant(
                'messages.user_with_email_exists',
              );
              this.error = true;
              this.userToLink = searchResults[0];
              //this.linkUser.toggle(event);
              this.confirmationService.confirm({
                key: 'user_key',
                header: this.translate.instant('general.confirm'),
                acceptLabel: this.translate.instant('general.yes'),
                rejectLabel: this.translate.instant('general.no'),
                message: this.translate.instant(
                  'messages.user_exists_link_to_bikeshop',
                  { username: this.UserForm.controls['Email'].value },
                ),
                accept: () => {
                  if (this.isCurrentUserAdmin) {
                    this.isAdmin = true;
                  } else {
                    this.isWorkshopManager = true;
                  }
                  this.linkUserToPartner();
                },
              });
            }
          } else {
            //Allow user to be linked.
            this.userExists = false;
            this.userLinkedToPartner = false;
            this.error = false;
            //this.enableControls();
          }
        });
    }
  }

  next() {
    if (this.UserForm.value.Password === this.UserForm.value.ConfirmPassword) {
      if (this.UserForm.valid) {
        this.step++;
        this.error = false;
        this.errorMessage = '';
      } else {
        this.error = true;
        this.errorMessage =
          'Please make sure all fields are filled out with correct information';
      }
    } else {
      this.error = true;
      this.errorMessage = "The password and confirm password don't match";
    }
  }

  back() {
    this.step--;
  }

  makeTechnician() {
    var technician = {
      Firstname: this.user.Name,
      Surname: this.user.Surname,
      HoursPerDay: 8,
      IsActive: true,
      PartnerID: this.partner.ID,
      UserID: this.user.ID,
    };
    this.technicianService.saveTechnician(technician).subscribe(
      (technician) => {
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant('messages.technician_linked', {
            name: technician.Firstname,
          }),
        });
        this.busy = false;
        this.modal.close();
      },
      (err) => {
        this.error = true;
        this.errorMessage =
          'You have reached you limit for adding technicians. You can make other technician inactive or upgrade your plan';
      },
    );
  }

  linkUserToPartner() {
    let UserRoles = [];
    if (this.isWorkshop) {
      var makeTechnician = this.isTechnician || this.isFitter;
      if (this.isTechnician)
        UserRoles.push({ RoleID: 1, PartnerID: this.partnerID });
      if (this.isAdmin)
        UserRoles.push({ RoleID: 2, PartnerID: this.partnerID });
      if (this.isWorkshopManager)
        UserRoles.push({ RoleID: 3, PartnerID: this.partnerID });
      if (this.isServiceLead)
        UserRoles.push({ RoleID: 9, PartnerID: this.partnerID });
      if (this.isShopRideAdmin)
        UserRoles.push({ RoleID: 10, PartnerID: this.partnerID });
      if (this.isFitter)
        UserRoles.push({ RoleID: 4, PartnerID: this.partnerID });
    } else {
      UserRoles.push({ RoleID: 2, PartnerID: this.partnerID });
    }
    
    var roles = UserRoles.map((x) => {
      return x.RoleID;
    });

    this.cyclistService.updateRoles(this.userToLink.ID, roles, this.partnerID).subscribe((user) => {
      this.user = user;
      this.error = false;
      this.busy = false;
      this.modal.close();
    }, (error) => {
      this.error = true;
      this.errorMessage = 'There was an error linking the user to the store';
    });

    /*this.cyclistService
      .getCyclistById(this.userToLink.ID)
      .subscribe((cyclist) => {
        cyclist.PartnerID = this.partner.ID;
        cyclist.Partner = null;
        cyclist.IsPartnerUser = true;
        cyclist.ShowCyclistSite = true;
        cyclist.IsImpersonating = false;
        cyclist.Salutation =
          cyclist.Name + ' ' + cyclist.Surname + ' (' + cyclist.UserName + ')';
        cyclist.IsStravaLinked_Description = cyclist.IsStravaLinked
          ? 'Linked'
          : 'Not Linked';
        cyclist.Messages = [];
        cyclist.UnitsOfMeasureID = this.DefaultUnitOfMeasure;
        cyclist.UserRoles = UserRoles;
        this.cyclistService.saveCyclist(cyclist).subscribe((user) => {
          this.user = user;
          this.error = false;
          this.busy = false;
          if (makeTechnician) {
            this.makeTechnician();
          } else {
            this.busy = false;
            this.modal.close();
          }
        });
      });*/
  }

  createUser(formData) {
    if (
      this.isTechnician ||
      this.isFitter ||
      this.isAdmin ||
      this.isWorkshopManager ||
      this.isServiceLead ||
      this.isShopRideAdmin
    ) {
      let user = formData;
      user.GenderID = 1;
      user.Username = user.Email;
      user.DateOfBirth = moment().toISOString();
      user.PartnerID = this.partnerID;
      user.Surname = user.Surname ? user.Surname : '';
      this.busy = true;
      this.error = false;
      this.userService.createCustomer(user).subscribe(
        (newUser) => {
          this.userToLink = newUser.Data;
          this.linkUserToPartner();
        },
        (error) => {
          this.busy = false;
        },
      );
    } else {
      this.busy = false;
      this.error = true;
      this.errorMessage = 'You have to pick at least one role';
    }
  }
}
